<template>
  <main class="home-screen">
    <div class="home-overlay">
      <section class="home-hero" aria-label="BikeLife Startseite">
        <div class="brand-row">
          <span class="brand-icon">
            <v-icon size="34">mdi-bike</v-icon>
          </span>
          <span class="brand-name">BikeLife</span>
        </div>

        <div class="hero-copy">
          <h1>Deine Aktivität.<br>Deine Gesundheit.<br><span>Dein Plan.</span></h1>
          <p>
            Verwalte Radtouren, Gesundheitsdaten, Termine und Fortschritte an einem Ort.
          </p>
        </div>

        <nav class="home-actions" aria-label="Startbereiche">
          <router-link
            v-for="item in primaryActions"
            :key="item.to"
            class="home-action"
            :to="item.to"
          >
            <v-icon :color="item.color" size="34">{{ item.icon }}</v-icon>
            <span>{{ item.title }}</span>
          </router-link>
        </nav>
      </section>
    </div>
  </main>
</template>

<script>
export default {
  name: 'HomeScreen',

  data () {
    return {
      primaryActions: [
        {
          title: 'Radaktivitäten',
          to: '/activities',
          icon: 'mdi-bike',
          color: '#2563eb',
        },
        {
          title: 'Gesundheit',
          to: '/health',
          icon: 'mdi-heart-pulse',
          color: '#16a34a',
        },
        {
          title: 'Kalender',
          to: '/calendar',
          icon: 'mdi-calendar-month',
          color: '#4f46e5',
        },
        {
          title: 'Dashboard',
          to: '/dashboard',
          icon: 'mdi-view-dashboard-outline',
          color: '#7c3aed',
        },
      ],
    }
  },
}
</script>

<style scoped>
.home-screen {
  min-height: calc(100vh - 64px);
  background: url('@/assets/img/bikelife_homescreen.png') center center / cover no-repeat;
  color: #071426;
  margin: -16px;
  position: relative;
}

.home-overlay {
  min-height: calc(100vh - 64px);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.58) 0%, rgba(255, 255, 255, 0.18) 55%, rgba(255, 255, 255, 0.05) 100%);
  display: flex;
  align-items: stretch;
}

.home-hero {
  width: min(760px, 100%);
  padding: clamp(28px, 5vw, 64px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 36px;
}

.brand-row {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  font-size: 2rem;
  font-weight: 800;
}

.brand-icon {
  width: 62px;
  height: 62px;
  border: 3px solid #2563eb;
  border-radius: 50%;
  color: #2563eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.74);
}

.hero-copy h1 {
  font-size: clamp(3rem, 6vw, 5.6rem);
  font-weight: 900;
  line-height: 1.08;
  margin: 0;
}

.hero-copy h1 span {
  color: #2563eb;
}

.hero-copy p {
  font-size: 1.35rem;
  line-height: 1.45;
  max-width: 540px;
  margin: 28px 0 0;
}

.home-actions {
  display: grid;
  grid-template-columns: repeat(4, minmax(120px, 1fr));
  gap: 14px;
  max-width: 720px;
}

.home-action {
  min-height: 132px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.12);
  color: #0f172a;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  padding: 18px;
}

.home-action span {
  font-size: 1rem;
  font-weight: 700;
}

.home-action:hover {
  background: rgba(255, 255, 255, 0.94);
  transform: translateY(-1px);
}

@media (max-width: 960px) {
  .home-screen {
    min-height: calc(100dvh - 56px);
    background-image: url('@/assets/img/bikelife_homescreen_mobile.png');
    background-position: center center;
  }

  .home-overlay {
    min-height: calc(100dvh - 56px);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.18) 46%, rgba(255, 255, 255, 0.72) 100%);
  }

  .home-hero {
    box-sizing: border-box;
    width: 100%;
    min-height: calc(100dvh - 56px);
    padding: 18px 18px calc(28px + env(safe-area-inset-bottom));
    justify-content: flex-end;
    gap: 14px;
  }

  .brand-row,
  .hero-copy {
    display: none;
  }

  .home-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    max-width: none;
  }

  .home-action {
    min-height: 82px;
    padding: 12px;
    gap: 8px;
    background: rgba(255, 255, 255, 0.86);
  }

  .home-action span {
    font-size: 0.92rem;
  }
}

@media (max-width: 560px) {
  .home-screen,
  .home-overlay,
  .home-hero {
    min-height: calc(100dvh - 56px);
  }

  .home-hero {
    padding: 14px 14px calc(26px + env(safe-area-inset-bottom));
  }

  .home-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .home-action {
    min-height: 74px;
    padding: 10px;
  }
}
</style>
